import { Component } from "../../components/base/Component";
import { ComponentFactory } from "../../services/ComponentFactory";
import { ICfa } from "../../models/ICfa";
import { GiftCardService } from "./GiftCardService";
export class GiftCardForm extends Component {
	dxeBearerToken: string | undefined;
	form: HTMLFormElement;

	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		if (this._element.tagName !== "FORM") {
			throw new Error(`Non-form element passed in, element: ${this._element}`);
		}

		this.form = this._element as HTMLFormElement;
		// tslint:disable-next-line
		this.initialize();
	}

	private async initialize(): Promise<void> {
		this.applyValidationRules(this.form);
		this.form.addEventListener("change", e => this.handleCustomEmailEffect());
		this.form.addEventListener("submit", e => this.handleSubmission(e));

		// confirm that user upload is accepted file type
		this.handleUserUpload();
	}

	handleUserUpload(): void {
		const uploadInput = this._element.querySelector("#image");
		const { acceptedFiles = "", customInputUploadMsg = "" } =
			this._element?.dataset;
		const acceptedFilesClean = acceptedFiles.split(",").map(i => i.trim());
		uploadInput?.addEventListener("change", e => {
			const ext = e.target?.value?.match(/\.([^\.]+)$/)[1];
			console.log(e);
			if (!acceptedFilesClean.includes(ext)) {
				const validator = $(this.form).validate();
				validator.showErrors({
					image: customInputUploadMsg
				});
				e.target?.value = "";
			} else {
				$(uploadInput).trigger("blur");
			}
		});
	}

	handleCustomEmailEffect(): void {
		const customEmailDiv = this._element.querySelector(".email-verify-div");

		if (!customEmailDiv) {
			console.warn(
				"No custom email div found. Check html and selector: .email-verify-div"
			);
			return;
		}

		const customEmailCheckbox = this._element.querySelector(
			"input[value='customEmailOption']"
		);

		if (customEmailCheckbox?.checked) {
			$(customEmailDiv).slideDown();
		} else {
			$(customEmailDiv).slideUp();
		}
	}

	private applyValidationRules(form: HTMLFormElement): void {
		const messages = this._element.dataset;
		const errorClass = "hasError";

		$(form).validate({
			errorClass: "hasError",
			errorPlacement: (error, element) => {
				error.appendTo(element.next(".error-container"));
			},
			highlight: element => {
				$(element).parent().addClass(errorClass);
			},
			messages: {
				fullname: {
					required: messages.customNameMsg ?? ""
				},
				email: messages.customEmailMsg ?? "",
				address: messages.customAddressMsg ?? "",
				replacementReason: messages.customReplaceReasonMsg ?? "",
				acknowledge: messages.customAcknowledgeMsg ?? "",
				customEmail: messages.customEmailVerifyMsg ?? ""
			},
			rules: {
				fullname: {
					required: true
				},
				email: {
					email: true,
					required: true
				},
				address: {
					required: true
				},
				replacementReason: {
					required: true
				},
				acknowledge: {
					required: true
				},
				customEmail: {
					email: true,
					required: "#customEmailOption:checked"
				}
			},
			unhighlight: element => {
				$(element).parent().removeClass(errorClass);
			}
		});
	}

	private async handleSubmission(e: Event): Promise<void> {
		e.preventDefault();
		this.toggleSubmitBtn(false);
		const formHasErrors = !this.validate();
		if (formHasErrors) {
			this.toggleSubmitBtn(true);

			return;
		}

		await this.submitForm();
	}

	private async submitForm(): Promise<void> {
		const {
			submissionEndpoint = "",
			formDatasourceId = "",
			redirectSuccess,
			redirectError
		} = this._element.dataset;

		let formData = new FormData(this.form);
		formData.append("formDatasourceId", formDatasourceId);

		const [result, err] = await GiftCardService.sendForm(
			submissionEndpoint,
			formData
		);

		if (err) {
			console.warn("Error in submitting form.");
			window.location.href = redirectError;

			return;
		}

		if (result) {
			window.location.href = redirectSuccess;
		} else {
			// Account for false response from BE:
			window.location.href = redirectError;
		}
	}

	private toggleRecaptchaErr(toggleOn: boolean): void {
		const recaptchaField = this._element.querySelector(
			"[data-element='recaptchaField']"
		);

		if (!recaptchaField) {
			console.warn("No recaptcha field found. Check DOM.");

			return;
		}

		toggleOn
			? recaptchaField.classList.add("display")
			: recaptchaField.classList.remove("display");
	}

	private validate(): boolean {
		if (this._element) {
			return $(this._element).valid();
		}

		return false;
	}

	private toggleSubmitBtn(toggleOn: boolean): void {
		const submitBtn = this._element.querySelector("button[type='submit']");
		const disabledClass = "disabled";

		if (!submitBtn) {
			throw new Error(`Submit button not found for ${submitBtn}`);
		}

		toggleOn
			? submitBtn.classList.remove(disabledClass)
			: submitBtn.classList.add(disabledClass);
	}
}

ComponentFactory.registerComponent("giftCardForm", GiftCardForm);
